import type { Action, Subject } from '@/components/authnz/types/rbac';

/** Production authorize surface — string action/subject pairs only (no object subjects). */
export const PRODUCTION_ACTIONS: readonly Action[] = [
  'manage',
  'read',
  'create',
  'update',
  'delete',
  'access',
  'switch',
] as const;

export const PRODUCTION_SUBJECTS: readonly Subject[] = [
  'all',
  'Client',
  'Assessment',
  'PostureAnalysis',
  'Drill',
  'DrillPlan',
  'DrillPlanAssignment',
  'Category',
  'Settings',
  'AdminMode',
  'RoleManagement',
  'Dashboard',
  'Chat',
  'Agent',
  'ProgressionModel',
  'Coaching',
  'Subscription',
  'Product',
  'ClientProspect',
  'FunnelAnalytics',
] as const;

export interface ProductionAbilityCheck {
  action: Action;
  subject: Subject;
}

export const PRODUCTION_ABILITY_MATRIX: readonly ProductionAbilityCheck[] =
  PRODUCTION_ACTIONS.flatMap((action) =>
    PRODUCTION_SUBJECTS.map((subject) => ({ action, subject })),
  );
